<template>
  <div>
    <div class="specie-btn">
      <v-btn color="primary" @click="uploadDialog = true">品種を{{ $t('add') }}</v-btn>
    </div>

    <v-dialog v-model="uploadDialog" persistent>
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          <div>品種を追加する</div>
        </v-card-title>
        <v-divider></v-divider>

        <div class="mt-2 px-2">
          <v-text-field
            v-model="name"
            label="品種名を入力してください"
            placeholder=" "
            outlined
            hide-details
          ></v-text-field>
        </div>
        <div class="mt-2 px-2">
          <v-text-field
            v-model="name_furigana"
            :label="$t('kana_input')"
            :placeholder="$t('only_kana')"
            outlined
            hide-details
          ></v-text-field>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog()">{{ $t("cancel") }}</v-btn>
          <v-btn text @click="save" :disabled="!canSave()">{{ $t("save") }}</v-btn>
        </v-card-actions>
      </v-card>
      <div class="mt-2">
    </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    genusId: {
      type: Number,
      default: null
    },
    edit: {
      type: Number,
      default: null
    }
  },
  watch: {
    edit(specieId) {
      const specie = this.$store.state.flowerSpecie.list[specieId];
      this.name = specie && specie.name;
    }
  },
  data() {
    return {
      name: null,
      name_furigana: null,
      uploadDialog: false,
      img: null
    };
  },
  created() {
    const newImage = this.$store.getters["flowerSpecie/newImage"];
    if (newImage !== null) {
      this.img = newImage.image_url;
    }
  },
  methods: {
    imageHandler(e) {
      this.img = e;
    },
    clearImage() {
      this.img = null;
      this.$store.dispatch("flowerSpecie/setNewImage", null);
    },
    closeDialog() {
      this.clearImage();
      this.uploadDialog = false;
    },
    async save() {
      if (!this.genusId) return;

      if (this.edit && (this.name || this.name_furigana || this.img)) {
        const data = {};
        if (this.name) data.name = this.name;
        if (this.name_furigana) data.name_furigana = this.name_furigana;
        if (this.img) data.data = this.img;

        await this.$store.dispatch("flowerSpecie/putFlowerSpecie", {
          specieId: this.specieId,
          data
        });

        this.$emit("finish", this.edit);

        return;
      }

      if (!this.genusId || !this.name || !this.name_furigana) { return; }

      if (!this.name_furigana.match(/^[ァ-ヶー]+$/)) return;

      const postData = {
        name: this.name,
        name_furigana: this.name_furigana
      };
      if (this.img) postData.data = this.img;

      const id = await this.$store.dispatch("flowerSpecie/postFlowerSpecie", {
        genusId: this.genusId,
        data: postData,
      });

      if (!this.img) {
        this.$store.dispatch("flowerSpecie/setIsCreatedWithoutImage", true);
      }

      this.$emit("finish", id);
    },
    canSave() {
      if (!this.genusId || !this.name || !this.name_furigana) { return false; }
      if (!this.name_furigana.match(/^[ァ-ヶー]+$/)) return false;

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.specie {
  &-btn {
    text-align: right;
    margin-top: -20px;
  }
}
</style>
